import React from "react";
import { Globe } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

/**
 * Compact currency picker for the navbar. Uses a native <select> overlay
 * so it works reliably on every mobile browser. Visual chip stays minimal —
 * shows the active currency code + globe icon.
 */
const CurrencyPicker = ({ className = "" }) => {
  const { displayCurrency, supported, setCurrency } = useCurrency();
  const codes = Object.keys(supported || {});
  if (codes.length === 0) return null;
  return (
    <label className={`relative inline-flex items-center gap-1 h-9 px-2.5 rounded-md border border-black/10 bg-white hover:bg-black/5 cursor-pointer transition-colors ${className}`} data-testid="nav-currency-picker">
      <Globe className="w-3.5 h-3.5 text-muted-foreground" />
      <span className="font-sans-ui text-xs font-semibold tabular-nums">{displayCurrency}</span>
      <select
        value={displayCurrency}
        onChange={(e) => setCurrency(e.target.value)}
        aria-label="Display currency"
        data-testid="nav-currency-select"
        className="absolute inset-0 opacity-0 cursor-pointer"
        style={{ WebkitAppearance: "menulist", touchAction: "manipulation" }}
      >
        {codes.map((code) => (
          <option key={code} value={code}>
            {code} — {(supported[code]?.symbol || "").trim()} {supported[code]?.name}
          </option>
        ))}
      </select>
    </label>
  );
};

export default CurrencyPicker;
